import { render } from "./SelfCheckIn.vue?vue&type=template&id=bd4cc69c&scoped=true&ts=true"
import script from "./SelfCheckIn.vue?vue&type=script&lang=ts"
export * from "./SelfCheckIn.vue?vue&type=script&lang=ts"

import "./SelfCheckIn.vue?vue&type=style&index=0&id=bd4cc69c&scoped=true&lang=css"

import exportComponent from "D:\\Ventla Code\\New Admin\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bd4cc69c"]])

export default __exports__